// filepath: d:\projects\giveinkind\inkind-monorepo\packages\@gik\core\pages\ArticlesSitemap.tsx
import { useSiteMap } from '@gik/api/legal';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { PageSection } from '@gik/ui-legacy/gik/PageSection';
import React from 'react';
import { useEnvStore } from '../store/EnvStore';
import bemBlock from '../utils/bemBlock';
import { ErrorPageSection } from './Error/ErrorPageSection';
import { SitemapSectionView } from './SitemapSectionView';

function ArticlesSitemapComp() {
  const bem = bemBlock('sitemap');
  const { data } = useSiteMap();
  const rawBaseUrl = useEnvStore.getState().FRONTEND_BASE_URL || '/';
  const frontendBaseUrl = rawBaseUrl.endsWith('/') ? rawBaseUrl : rawBaseUrl + '/';

  const prefixes = {
    articles: 'articles',
  };

  const articles = React.useMemo(() => {
    return data
      ?.filter(item => item.url.startsWith(prefixes.articles + '/'))
      .map(page => {
        return {
          url: page.url.replace(prefixes.articles + '/', ''),
          title: page.title,
        };
      });
  }, [data, prefixes.articles]);

  return (
    <PageSection className={bem()}>
      <div className="tw-flex tw-flex-wrap">
        <SitemapSectionView baseUrl={frontendBaseUrl} title="Articles" items={articles} prefix={prefixes.articles} />
      </div>
    </PageSection>
  );
}

export const ArticlesSitemapPage = withComponentErrorBoundary(ArticlesSitemapComp, { ErrorFallback: ErrorPageSection });
